import React from 'react'

function Notifications() {
  return (
    <div className="dashboard">
        <h1>Notifications</h1>
    </div>
  )
}

export default Notifications